import WarningIcon from '@mui/icons-material/Warning';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    open: boolean;
    title: string;
    text: string;
    items: string[];
    confirmText: string;
    onConfirm: () => void;
    onClose: () => void;
}

// Asks to continue although some of the chosen days are closed days, listing what is affected
export const ClosedDaysWarningDialog: FC<Props> = ({ open, title, text, items, confirmText, onConfirm, onClose }) => {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                <Grid container direction="row" alignItems="center">
                    <WarningIcon color="secondary" style={{ marginRight: '0.5em' }} />
                    {title}
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Typography color="text.secondary">{text}</Typography>
                <Box component="ul" sx={{ mt: 0, mb: 2, pl: 3, color: 'text.secondary' }}>
                    {items.map((item, index) => (
                        <li key={`${index}-${item}`}>{item}</li>
                    ))}
                </Box>
                <Typography color="text.secondary">{confirmText}</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={onConfirm}>
                    {t('yes')}
                </Button>
                <Button variant="outlined" onClick={onClose}>
                    {t('no')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
